<ion-header>
  <ion-toolbar [color]='color'>
    <ion-title>{{ titulo }}</ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar #search animated focus="true" (ionChange)="buscar($event)" debounce="1000" placeholder="Buscar">
    </ion-searchbar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-item lines="full" *ngFor="let item of catalogo | filtro:strBusqueda:[nombre, descripcion]"
      [color]="(!!item.color) ? 'item.color' : 'light'" (click)="onClick(item)">
      <ion-label class="ion-text-wrap">
        <ion-text color="primary">
          <h2>{{ item[nombre] }}</h2>
        </ion-text>
        <ion-text color="medium">
          <p>{{ item[descripcion] }}</p>
        </ion-text>
        <p color="medium"></p>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>